import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-14 gap-4">
          <div>
            <p className="text-xs font-semibold text-foreground-500 uppercase tracking-[0.2em] mb-3 font-label">
              Shop Categories
            </p>
            <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 font-heading leading-[1.15]">
              Find Your
              <br />
              Product Niche
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-[340px] leading-relaxed">
            Browse all 14 curated product categories — each linked directly to our main platform for seamless shopping.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => {
            const isLarge = cat.size === "large";
            const colSpan = isLarge ? "md:col-span-2 md:row-span-2" : "";

            return (
              <a
                key={cat.id}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className={`group relative rounded-[24px] bg-background-50 overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02] flex flex-col ${colSpan}`}
              >
                {/* Image Area */}
                <div className={`relative ${isLarge ? "h-[340px]" : "h-[180px]"} w-full shrink-0`}>
                  <img
                    src={cat.imageUrl}
                    alt={`${cat.name} - Browse ${cat.name} on Kaspreadsheet`}
                    className="w-full h-full object-cover object-center"
                    loading="lazy"
                  />
                  {/* Gradient for text readability */}
                  <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-background-50/10 to-transparent"></div>

                  {/* Tag */}
                  {cat.tag && (
                    <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-foreground-950 text-background-50 text-[10px] font-semibold uppercase tracking-wider z-10">
                      {cat.tag}
                    </span>
                  )}
                </div>

                {/* Text Area */}
                <div className="p-4 pt-3 flex flex-col items-center text-center flex-1">
                  <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 text-foreground-600 group-hover:text-foreground-950 group-hover:bg-background-200 transition-colors mb-2">
                    <i className={`${cat.icon} text-lg`}></i>
                  </span>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 font-heading group-hover:text-foreground-800 transition-colors">
                    {cat.name}
                  </h3>
                  <p className="text-[11px] text-foreground-500 mt-1 leading-relaxed opacity-70 group-hover:opacity-100 transition-opacity">
                    Shop {cat.name.toLowerCase()} on Kaspreadsheet
                  </p>
                  <span className="inline-flex items-center gap-1 mt-2 text-[10px] font-medium text-accent-600 opacity-0 group-hover:opacity-100 transition-all duration-200 translate-y-1 group-hover:translate-y-0">
                    View Category <i className="ri-arrow-right-line text-[10px]"></i>
                  </span>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}